import React from 'react';
import './App.css';
import Header from './Header'; // Capital H to match Header.js

function App() {
  return (
    <div className="App">
      {/* Custom Header */}
      <Header />

      {/* Main content */}
      <main style={{ padding: '2rem' }}>
        <h1>Welcome to Stredisco</h1>
        <p>This is your main page content. Edit it as you like!</p>
      </main>
    </div>
  );
}

export default App;